import React, {useState, useEffect} from 'react'
import PropTypes from 'prop-types'
import {defineMessage, FormattedMessage, useIntl} from 'react-intl'
import {CheckIcon} from '@salesforce/retail-react-app/app/components/icons'
import {
    Box,
    Button,
    Text,
    Container,
    SimpleGrid,
    Stack,
    useDisclosure
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {pxToRem} from '../../../utills/pxToRem'
import useCustomFetch from '../../../hooks/useStoreDetails'
import {useAccessToken} from '@salesforce/commerce-sdk-react'
import {useCurrentBasket} from '@salesforce/retail-react-app/app/hooks/use-current-basket'
import {storeAddressCardsWrapper, storeAddressText} from './bopis-address.style'
import {useCheckout} from '../util/checkout-context'

const BopisAddress = ({isAllBopisItems = false, disableContinue}) => {
    const {formatMessage} = useIntl()
    const {token} = useAccessToken()
    const {data: basket} = useCurrentBasket()
    const {step, STEPS, goToStep, goToNextStep} = useCheckout()

    const uniqueStoreIds = [
        ...new Set(basket?.productItems?.map((product) => product?.c_selectedStoreId))
    ]

    const {response, loading, error} = useCustomFetch(token, uniqueStoreIds)
    const storesData = response?.data

    const handleContinue = () => {
        goToStep(STEPS.PAYMENT)
    }

    return (
        <>
            <Text
                color={'black'}
                marginBottom={pxToRem(10)}
                fontSize={{base: pxToRem(14), lg: pxToRem(16)}}
                fontWeight={500}
                lineHeight={'normal'}
                letterSpacing={pxToRem(1)}
                mb={{base: pxToRem(5), lg: pxToRem(10)}}
            >
                {formatMessage({
                    defaultMessage:
                        'Store Pickup - Watch your email, we’ll let you know when it’s ready!',
                    id: 'checkout.shipping.bopis.label'
                })}
            </Text>

            <Box sx={storeAddressCardsWrapper}>
                {storesData?.length
                    ? storesData?.map((store) => {
                          return (
                              <Box key={store?.id}>
                                  <Text sx={storeAddressText}>{store?.name}</Text>
                                  <Text sx={storeAddressText}>{store?.address1}</Text>
                                  <Text sx={storeAddressText}>
                                      {store?.city}, {store?.stateCode} {store?.postalCode}
                                  </Text>
                                  <Text sx={storeAddressText}>
                                      {store?.countryCode == 'US'
                                          ? 'United States'
                                          : store?.countryCode}
                                  </Text>
                              </Box>
                          )
                      })
                    : null}
            </Box>

            {!disableContinue && (
                <Button
                    onClick={handleContinue}
                    // isDisabled={disableContinue}
                    variant="red"
                    width={'100%'}
                    mt={{base: pxToRem(20), lg: pxToRem(25)}}
                    _hover={{
                        _disabled: {
                            backgroundColor: 'cav_red'
                        },
                        _active: {
                            color: 'white'
                        },
                        backgroundColor: 'white'
                    }}
                >
                    Continue
                </Button>
            )}
        </>
    )
}

BopisAddress.propTypes = {
    isAllBopisItems: PropTypes.bool,
    disableContinue: PropTypes.bool
}

export default BopisAddress
